<template>
    <div class="op-goods" @click="goGoodsDetail">
        <div class="goods-img"><img :src="goodsData.skuImage" alt=""></div>
        <div class="goods-info">
            <div class="goods-title">{{goodsData.productName}}</div>
            <div class="goods-sku">
                <div class="sku-info">{{goodsData.specificationValue}}</div>
                <div class="num">x{{goodsData.quantity}}</div>
            </div>
            <van-tag color="rgba(238,46,80,0.2)" text-color="#EE2E50" round v-if="goodsData.aaa">自营</van-tag>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        goodsData: Object
    },
    data() {
        return {

        };
    },
    methods: {
        goGoodsDetail() {
            this.esvOpenPage({ name: 'OPGoodsdetail', query: { productId: this.goodsData.productId } });
        }
    }
};
</script>

<style lang="scss">
    .op-goods {
        font-size: 12px;
        display: flex;
        // justify-content: space-between;
        .goods-img {
            flex: none;
            width: 80px;
            height: 80px;
            margin-right: 12px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .goods-info {
            width: 100%;
            .goods-title {
                color: $text-color;
                line-height: 16px;
                @include textoverflow
            }
            .goods-sku {
                display: flex;
                justify-content: space-between;
                line-height: 15px;
                color: #969799;
                .sku-info {
                    @include textoverflow
                }
                .num {
                    flex: none;
                    margin-left: 44px;
                }
            }
        }

    }
</style>
